import countryToCurrency, { Countries } from "country-to-currency";
import countries from "countries-phone-masks";
import { Country } from "@jugl-web/ui-components/cross-platform/PhoneInput/types";
import { currencyList } from "./currencyList";

const countriesMasks = countries as unknown as Country[];

type PhoneMasksCountry = {
  name: string;
  code: string;
  iso: string;
  flag: string;
  mask: string;
};

export type CurrenciesListItem = {
  code: string;
  name: string;
  symbol: string;
  flag: string;
  country_code: string;
};

let cachedCurrenciesList: CurrenciesListItem[] | null = null;

export const getCurrenciesList = () => {
  if (cachedCurrenciesList) {
    return cachedCurrenciesList;
  }

  const currenciesList: CurrenciesListItem[] = [];
  const priorityCountries = ["US", "IN", "SV"];

  priorityCountries.forEach((countryCode) => {
    const country = countriesMasks.find((item) => item.iso === countryCode);
    if (!country) return;

    const currencyCode = countryToCurrency[country.iso as Countries];
    if (!currencyCode) return;

    const currencyInfo = currencyList[currencyCode];
    if (!currencyInfo) return;

    currenciesList.push({
      code: currencyCode,
      name: currencyInfo.name,
      symbol: currencyInfo.symbol,
      flag: country.flag,
      country_code: country.iso,
    });
  });

  countriesMasks.forEach((item: PhoneMasksCountry) => {
    if (priorityCountries.includes(item.iso)) {
      return;
    }

    const currencyCode = countryToCurrency[item.iso as Countries];
    if (!currencyCode) return;

    const currencyInfo = currencyList[currencyCode];
    if (!currencyInfo) return;

    currenciesList.push({
      code: currencyCode,
      name: currencyInfo.name,
      symbol: currencyInfo.symbol,
      flag: item.flag,
      country_code: item.iso,
    });
  });

  cachedCurrenciesList = currenciesList;
  return currenciesList;
};
